import React, { Component, Fragment } from 'react';
import { IntlProvider, FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { authListen, logout, checkStoredLanguage } from './store/actions/indexActions';
import * as actionTypes from './store/actions/allActionList';

/** Import hoc wrapper functions **/
import Routes from './utils/hoc/Routes';
import Navigations from './utils/hoc/Navigations';
import AppLoader from './components/Loaders/AppLoader/AppLoader';
import LoginModal from './components/Modals/Auth';
import ReportForm from './components/ReportForm';
import Backdrop from './components/Backdrop/Backdrop';

/** Import translations **/
import enTranslate from './config/locales/application-wide/app-locale-en';
import itTranslate from './config/locales/application-wide/app-locale-it';
import tlTranslate from './config/locales/application-wide/app-locale-tl';

const languages = {
  //Global
  en: enTranslate,
  it: itTranslate,
  tl: tlTranslate,
};

class App extends Component {
  componentDidMount() {
    /** Simple Analytics Implementation **/
    if (process.env.NODE_ENV === 'production') {
      const analytics = document.createElement('script');
      const noImgSrc = document.createElement('noscript');
      const gifImg = document.createElement('img');

      analytics.src = 'https://analytics.intereact.online/latest.js';
      analytics.async = true;
      analytics.defer = true;
      gifImg.src = 'https://analytics.intereact.online/noscript.gif';
      gifImg.alt = '';

      noImgSrc.appendChild(gifImg);

      document.body.appendChild(analytics);
      document.body.appendChild(noImgSrc);
    }
    /**************************/

    this.props.onCheckStoredLanguage();
    this.props.onAuthListen();
  }

  logout = async () => {
    await this.props.onLogout();
    this.props.history.push('/');
    window.location.reload(false);
  };

  render() {
    const {
      lang,
      userData,
      logoutStarted,
      authListenStarted,
      authListenDone,
      showReportModal,
      reportType,
      idToReport,
      onUnsetReportFormOpen,
    } = this.props;

    const backdropInline = {
      display: logoutStarted ? 'block' : 'none',
      width: '100%',
      height: '100%',
    };

    const appContent =
      (authListenStarted && !authListenDone) ||
      (!authListenStarted && !authListenDone) ? (
        <AppLoader />
      ) : (
        <Fragment>
          <Navigations
            path={this.props.history.location.pathname}
            goBackToHome={() => this.props.history.push('/')}
            lang={lang}
            logout={this.logout}
            userData={userData}
            goToProfile={() => this.props.history.push(`/profile/me/${userData.user_id}`)}
          >
            <Routes auth={!authListenStarted && authListenDone && userData} />
          </Navigations>
          <div style={{ display: logoutStarted ? 'flex' : 'none' }}>
            <span>
              <FormattedMessage id='app.logout' />
            </span>
          </div>
          <Backdrop style={backdropInline} />
          {userData ? null : <LoginModal />}
          <ReportForm
            lang={lang}
            open={showReportModal}
            reportType={reportType}
            id={idToReport}
            unset={() => onUnsetReportFormOpen()}
          />
        </Fragment>
      );

    return (
      <IntlProvider locale={lang} messages={languages[lang]}>
        {appContent}
      </IntlProvider>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.locale.langLocale,
    authListenStarted: state.user.authListenStarted,
    authListenDone: state.user.authListenDone,
    userData: state.user.userData,
    logoutStarted: state.user.logoutStarted,
    showReportModal: state.modals.showReportModal,
    reportType: state.modals.reportType,
    idToReport: state.modals.idToReport,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAuthListen: () => dispatch(authListen()),
    onLogout: () => dispatch(logout()),
    onCheckStoredLanguage: () => dispatch(checkStoredLanguage()),
    onUnsetReportFormOpen: () => dispatch({ type: actionTypes.UNSET_REPORT_FORM_OPEN }),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
